// extracted by mini-css-extract-plugin
module.exports = {"view":"pT9pBxtyPW-9g3mBRhDrF","categoryImg":"_35brYUeafTxdnpo0VdAEcJ"};